import React, { useEffect, useState } from "react";
import LecturerNav from "../../navigation/LecturerNav";
import { Grid, CircularProgress } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux';
import { getLecturerProjects } from '../../actions/lecturerprojects';
import axios from 'axios';

/**
 * This page presents the lecturer with a list of all suggested projects by other lecturers so that they can browse what each project is.
 * @returns a list of all of the suggested projects by all lecturers
 */

function LecturerViewProjects() {

    const dispatch = useDispatch();
    const [allUsers, setAllUsers] = useState([]);
    useEffect(() => {
        if(allUsers.length === 0) {
            getAllUsers();
        }
        dispatch(getLecturerProjects());
    }, [dispatch, allUsers]);

    const getAllUsers = () => {
        axios.get('https://project-allocation-schedule.herokuapp.com/users').then(function (response) {
            setAllUsers(response.data)
        })
        .catch(function (error) {
            console.log(error);
        })
        .then(function () {
        });
    }

    const getUser = (id) => {
        let userName = "";
        if(allUsers.length > 0) {
            allUsers.forEach(element => {
                if(element._id === id) {
                    userName = element.firstName + " " + element.secondName
                }
            });
        }
        return userName;
    }

    let projects = []
    const response = useSelector((state) => state.lecturerprojects.data);
    if (response){
        projects = Array.from(response);
    }

    return(
        <div className="viewProjectsContainer">
            <LecturerNav/>
            <h1>View Projects</h1>
            {!projects.length ? <CircularProgress /> : (
                <Grid>
                    {projects.map((project) => (
                        <Grid className="paper mt4" key={project._id} item>
                            <p>{project.title}</p>
                            <p>{getUser(project.userID) || project.userID}</p>
                            <p>{project.description}</p>
                        </Grid>
                    ))}
                </Grid>
            )}
        </div>
    )
}

export default LecturerViewProjects